import styled from 'styled-components';
import { maxMobile, maxWidth, retina } from 'Utils/utilsStyle';
import SkeletonCustom from './SkeletonCustom';

const StyleWrapper = styled.div`
margin-top: 12px;
display: flex;
flex-direction: column;
align-items: flex-start;
justify-content: center;
.skeleton-box {
  &:nth-child(1) {
    width: 460px;
    min-width: 460px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      width: 405px;
      min-width: 405px;
    }
    @media all and (max-width: ${maxMobile}) {
      width: 290px;
      min-width: 290px;
    }
  }
  &:nth-child(2) {
    width: 404px;
    min-width: 404px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      width: 390px;
      min-width: 390px;
    }
    @media all and (max-width: ${maxMobile}) {
      width: 250px;
      min-width: 250px;
    }
  }
  &:nth-child(3) {
    width: 390px;
    min-width: 390px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      width: 370px;
      min-width: 370px;
    }
    @media all and (max-width: ${maxMobile}) {
      width: 250px;
      min-width: 250px;
    }
  }
  &:nth-child(4) {
    width: 349px;
    min-width: 349px;
     @media all and (max-width: ${maxMobile}) {
      width: 290px;
      min-width: 290px;
    }
  }
  &:nth-child(5) {
    width: 371px;
    min-width: 371px;
    @media all and (max-width: ${maxMobile}) {
      width: 260px;
      min-width: 260px;
    }
  }
  &:nth-child(6) {
    width: 338px;
    min-width: 338px;
     @media all and (max-width: ${maxMobile}) {
      width: 220px;
      min-width: 220px;
    }
  }
  &:nth-child(7) {
    width: 70px;
    min-width: 70px;
  }
}
`;

const ArticleDrawerParagraphSkeleton = function ArticleDrawerParagraphSkeleton() {
  return (
    <StyleWrapper>
      {[1, 2, 3, 4, 5, 6, 7].map(() => (
        <SkeletonCustom
          width="257px"
          height="12px"
          margin="0px 0px 10px 0px"
          marginSm="0px 0px 10px 0px"
        />
      ))}
    </StyleWrapper>
  );
};

export default ArticleDrawerParagraphSkeleton;
